import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../apiClient';
import { getQueryKeyBase, QUERY_KEYS } from '../queryClient';

// Config
import { crudConfig } from '../../../../common/conf/codes';

export const useCodeCollection = ({ sessionToken, constraintType, queryParam }) => {
    const queryConfig = {
        crudConfig: crudConfig,
        getQueryKey: getQueryKeyBase.bind(null, QUERY_KEYS.CODE_COLLECTION)
    };
    const Client = apiClient(queryConfig.crudConfig);
    const query = useQuery({
        queryKey: queryConfig.getQueryKey(constraintType),
        queryFn: () => {
            switch (constraintType) {
                case 'Code':
                    return Client.fetchByConstraintTypeCode(sessionToken, queryParam);
                case 'CodeSystem':
                    return Client.fetchByConstraintTypeCodeSystem(sessionToken, queryParam);
                case 'Concept':
                    return Client.fetchByConstraintTypeConcept(sessionToken, queryParam);
                case 'ValueSet':
                    return Client.fetchByConstraintTypeValueSet(sessionToken, queryParam);
                case 'List':
                    return Client.fetchByConstraintTypeList(sessionToken, queryParam);
                default:
                    return () => Promise.resolve();
            }
        },
        onSuccess: (data) => {
            console.log('Success', data);
        },
        onError: (data) => {
            console.log('Error', data);
        },
        keepPreviousData: true,
        refetchOnWindowFocus: false
    });

    return {
        data: query.data,
        isLoading: query.isLoading,
        isError: query.isError,
        error: query.error,
        refetch: async () => {
            await query.refetch();
        }
    };
};
